/* eslint-disable import/prefer-default-export */
import { AxiosResponse } from 'axios';
import api from '../../app/axios';

export const getMeetingByLocationApi = (id: string): Promise<AxiosResponse> => {
  return api.get(`meetings/getbylocation/${id}`);
};
